import { render } from "./App.vue?vue&type=template&id=d09b6736"
const script = {}

import "./App.vue?vue&type=style&index=0&id=d09b6736&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__